import React from 'react'
import { connect } from 'react-redux'
import {Field, reduxForm} from 'redux-form'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faRedo} from "@fortawesome/free-solid-svg-icons";
import {FormUtils} from '../utils/FormUtils';

const requiredPI = FormUtils.validators.required('Payment Instrument Id');

let UpdatePiForm = props => {
  const { handleSubmit, reset, submitting, onPrevious, disabled } = props;

  return (
    <div>
      <h3>Update Payment Instrument</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <Field className="form-control" label="Payment Instrument Id*" name="paymentInstrumentId" component={FormUtils.renderField} type="text" validate={requiredPI} />
        </div>
        <div className="form-group">
          <label htmlFor="language">Language</label>
          <Field className="form-control" name="language" component="input" type="text" />
        </div>
        <div className="form-group">
          <label htmlFor="customStyleId">Custom style id</label>
          <Field className="form-control" name="customStyleId" component="input" type="text" />
        </div>

        <div>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <Field name="hidePayButton" component="input" type="checkbox" /> <b>Hide Update Button</b>
              </label>
            </div>
          </div>
        </div>


        <div className="hr-line-dashed"></div>
        <div className="form-group m-b-none">
          <div className="col-xs-12">
            <div className="col-lg-4 col-md-4 col-xs-12 m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" onClick={onPrevious}>
                <FontAwesomeIcon icon={faChevronLeft} />
                <span className="btn-text">Previous</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 text-center m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" disabled={submitting} onClick={reset}>
                <FontAwesomeIcon icon={faRedo} />
                <span className="btn-text">Reset</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 m-b-xs">
              <button type="submit" className="btn btn-primary col-xs-12" disabled={disabled}>
                <span className="btn-text">Init Widget</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
};

UpdatePiForm = reduxForm({
  form: 'update-pi'
})(UpdatePiForm);

UpdatePiForm = connect(
  state => {
    const initialValues = {
      merchantId: state.config.environment.merchantId,
      language: 'en',
      paymentInstrumentId: null,
      customStyleId: null,
      hidePayButton: false
    };

    return {
      initialValues
    };
  }
)(UpdatePiForm);

export default UpdatePiForm



// WEBPACK FOOTER //
// ./src/update-pi/UpdatePiForm.js